interface HelpIconProps {
	color: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ color }) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.0001 0.272705C4.58043 0.272705 0.181885 4.67125 0.181885 10.0909C0.181885 15.5105 4.58043 19.9091 10.0001 19.9091C15.4197 19.9091 19.8182 15.5105 19.8182 10.0909C19.8182 4.67125 15.4197 0.272705 10.0001 0.272705ZM10.9819 16.9636H9.01825V15H10.9819V16.9636ZM13.0142 9.35452L12.1306 10.2578C11.4237 10.9745 10.9819 11.5636 10.9819 13.0363H9.01825V12.5454C9.01825 11.4654 9.46007 10.4836 10.167 9.76689L11.3844 8.52979C11.7477 8.17634 11.9637 7.68543 11.9637 7.14543C11.9637 6.06543 11.0801 5.1818 10.0001 5.1818C8.92007 5.1818 8.03643 6.06543 8.03643 7.14543H6.07279C6.07279 4.97561 7.83025 3.21816 10.0001 3.21816C12.1699 3.21816 13.9273 4.97561 13.9273 7.14543C13.9273 8.00943 13.5739 8.79489 13.0142 9.35452Z"
				fill={color}
			/>
		</svg>
	);
};

export default HelpIcon;
